import { render } from "./Confidentialites.vue?vue&type=template&id=c7fb24b8&scoped=true"
import script from "./Confidentialites.vue?vue&type=script&lang=js"
export * from "./Confidentialites.vue?vue&type=script&lang=js"

import "./Confidentialites.vue?vue&type=style&index=0&id=c7fb24b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fb24b8"]])

export default __exports__